import { Avatar }              from "@/components/ui/avatar";
import { Button }              from "@/components/ui/button";
import { Card }                from '@chakra-ui/react';
import EditIcon                from '@/assets/icons/EditIcon';
import { Grid }                from '@chakra-ui/react';
import { GridItem }            from '@chakra-ui/react';
import { Stack }               from '@chakra-ui/react';
import { SystemStyleObject }   from '@chakra-ui/react';
import { Text }                from '@chakra-ui/react';
import authStore               from "@/stores/authStore";
import { useNavigate }         from "react-router-dom";
import { useTranslation }      from "react-i18next";

const UserCard = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const currentUser = authStore.currentUser;
	
	return (
		<Card.Root
			variant="elevated"
			background={`transparent linear-gradient(180deg, #FFFFFF00 0%, #FFFFFFF8 55%, #FFFFFF 100%) 0% 0% no-repeat padding-box`}
		>
			<Grid
				{...styles.cardGrid.base}
				lg={styles.cardGrid.lg}
			>
				<GridItem
					paddingLeft={{ base: "unset", lg: "20px" }}
					paddingRight={{ base: "unset", lg: "20px" }}
				>
					<Avatar
						width={{ base: "100px", lg: "150px" }}
						height={{ base: "100px", lg: "150px" }}
						bg="defaultBackground"
						variant="outline"
						name={currentUser.fullName}
						src={currentUser.userMediaProfilePicture}
						shadow="lg"
					/>
				</GridItem>
				<GridItem
					alignSelf={{ base: "unset", lg: "center"}}
					justifySelf={{ base: "unset", lg: "start"}}
					paddingLeft={{ base: "unset", lg: "10px" }}
				>
					<Stack gap="7px" textAlign={{ base: "center", lg: "start" }}>
						<Text className='poppins-semibold' fontSize="18px">{ currentUser.fullName }</Text>
						<Text className='poppins-semibold' textDecoration="underline" fontSize="14px">{ currentUser.email }</Text>
					</Stack>
				</GridItem>
				<GridItem
					alignSelf={{ base: "unset", lg: "center"}}
					justifySelf={{ base: "unset", lg: "flex-end"}}
					paddingRight={{ base: "unset", lg: "20px" }}
				>
					<Button
						onClick={() => navigate('/infos')}
						paddingX="20px"
						paddingY="20px"
						variant="outline"
						shadow="md"
					>
						<EditIcon size="lg"  />
						{t('pages.home.userCard.actions.edit')}
					</Button>
				</GridItem>
			</Grid>
		</Card.Root>
	)
}

export default UserCard;

const styles: {
	[key: string]: {
		[key: string]: SystemStyleObject
	}
} = {
	cardGrid: {
		base: {
			gap: "20px",
			gridTemplateColumns: "1fr",
			justifyItems: "center",
			paddingTop: "40px",
			paddingRight: "30px",
			paddingBottom: "40px",
			paddingLeft: "30px",
		},
		lg: {
			gridTemplateColumns: "0.1fr 1fr 1fr"
		}
	},
};